import dayjs from 'dayjs';
import { E_Freq } from '../apis/service/CompanyReportApi.types';
const duration = require('dayjs/plugin/duration');
dayjs.extend(duration);
export const LIMITS = {
    // 邮箱限制
    LIMIT_EMAILS: 100,
    // 搜索公司长度限制
    LIMIT_SEARCH_CONPAMY_LENGTH: 128,
    // 每日每个并发导出专利数码
    LIMIT_PRE_DAY_CONCURRENCY_EXPORT_NUMBER: 20000,
    // https://confluence.zhihuiya.com/pages/viewpage.action?pageId=100894368#id-%E5%AE%A2%E6%88%B7%E8%A1%8C%E4%B8%BA%E5%88%86%E6%9E%90%E6%8A%A5%E5%91%8A-%E9%A2%91%E6%AC%A1%E4%B8%8E%E5%88%86%E6%9E%90%E6%97%B6%E9%95%BF
    // report跨度限制
    LIMIT_REPORT_RANGE: {
        // @ts-ignore
        [E_Freq.daily]: dayjs.duration(30, 'days'),
        // @ts-ignore
        [E_Freq.weekly]: dayjs.duration(1, 'years'),
        // @ts-ignore
        [E_Freq.monthly]: dayjs.duration(2, 'years'),
    },
};
export const dateFormat = 'YYYY-MM-DD';
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
// 表格翻页配置
export const tablePagination = {
    perPage: 10,
    perPageOptions: [10, 25, 50, 100],
};
export const fullLangName = {
    cn: 'zh_CN',
    en: 'en_US',
};
export const ProductIds = ['pro',
    'chemical',
    'report',
    '563398857b284d14a48575e06990b9e4',
    'a2f4c064c228430a84f6087b5f870487',
    'f3eefd043cf64b96a0310e5925c64f28',
    '623ddd4fb7f549a7bcdf49b828a9f2ac',
    'fa02dbb62b9248adb83135957c22ae44',
    'e5ce470917314759bb2a3184b6e62ca8',
    'ls360',
    'f207ca60ec064edbbcbc26997985400a',
    'innosnap_product',
    'c10832349f874c8fabd0e9ca74a2d92e',
    '8c7fad972a0e4003b630956268644903',
    'ba56dbe5eb61461dba5a47234700cc86',
    '895f1015a21741bb97019a928c2c578b',
    '974ff55f8941429fa7d7f81bd1a42023',
    'bae91377ed7b45209cd48e076392cbbb' // EUREKA
];
export var E_PRODUCT_IDS;
(function (E_PRODUCT_IDS) {
    /**
     * 数据库
     */
    E_PRODUCT_IDS["Analytics"] = "pro";
    E_PRODUCT_IDS["Discovery"] = "a2f4c064c228430a84f6087b5f870487";
    E_PRODUCT_IDS["Bio"] = "563398857b284d14a48575e06990b9e4";
    E_PRODUCT_IDS["Chemical"] = "chemical";
    E_PRODUCT_IDS["Synapse"] = "e5ce470917314759bb2a3184b6e62ca8";
    E_PRODUCT_IDS["Synapse_CN"] = "895f1015a21741bb97019a928c2c578b";
    E_PRODUCT_IDS["Insights"] = "report";
    /**
     * IpManagement
     */
    E_PRODUCT_IDS["IpManagement"] = "innosnap_product";
    E_PRODUCT_IDS["Innosnap"] = "innocloud";
    E_PRODUCT_IDS["Course2b"] = "623ddd4fb7f549a7bcdf49b828a9f2ac";
    E_PRODUCT_IDS["TFFI"] = "974ff55f8941429fa7d7f81bd1a42023";
    /**
     * ToC 学院
     */
    E_PRODUCT_IDS["Course"] = "f3eefd043cf64b96a0310e5925c64f28";
    /**
     * 海外 ToC 学院
     */
    E_PRODUCT_IDS["Academy"] = "fa02dbb62b9248adb83135957c22ae44";
    E_PRODUCT_IDS["Eureka"] = "bae91377ed7b45209cd48e076392cbbb";
    E_PRODUCT_IDS["YunChuang"] = "yunchuang";
    E_PRODUCT_IDS["Workspace"] = "f207ca60ec064edbbcbc26997985400a";
    E_PRODUCT_IDS["OpenApi"] = "ba56dbe5eb61461dba5a47234700cc86";
    E_PRODUCT_IDS["Lab"] = "fb1218dcdb5e468e9cd3eb56f26300b2";
    E_PRODUCT_IDS["CAS"] = "cas";
})(E_PRODUCT_IDS || (E_PRODUCT_IDS = {}));
export const E_LANG = {
    CN: 'CN',
    EN: 'EN',
    JP: 'JP',
    TW: 'TW',
};
export const languages = [
    E_LANG.CN,
    E_LANG.EN,
    E_LANG.JP,
    E_LANG.TW
];
